import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

import { usePageTitle } from '~/utils/tags'
import Metatags from '~/components/Metadata/Metatags'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { Lectures } from '~/static-pages/Lectures.page'

import { AppLanguage } from '~/types/locale'

import { DefaultLayout } from '~/shared/layouts'

const LecturesPage: NextPage = () => {
  const { t } = useTranslation('lectures')
  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} title={usePageTitle(t('title'))} />

      <DefaultLayout zeroPadding>
        <Lectures />
      </DefaultLayout>
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext<{ locale: AppLanguage }>) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
        ...COMMON_TRANSLATION_MODULE_NAMES,
        'lectures',
        'ourTeam',
      ])),
    },
  }
}

export default LecturesPage
